import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import GradesTable from './GradesTable';
import DropDown from '../Settings/Dropdown/DropDown';
import { classGrades } from '../../../../Store/api/professor/dashboard';
import './grades.css';

const Grades = ({ classId, sections = [], onToggle = null }) => {
  const dispatch = useDispatch();
  const [grades, setGrades] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [shownGrades, setShownGrades] = useState([]);
  const [filter, setFilter] = useState({
    submitted: false,
    missing: false,
  });
  const [selectedSections, setSelectedSections] = useState(sections.map((e) => e.sectionNumber));

  useEffect(() => {
    setIsLoading(true);
    dispatch(
      classGrades({
        id: classId,
        ...filter,
        onSuccess: (res) => {
          setGrades(res.data.data);
          setShownGrades(res.data.data);
          setIsLoading(false);
        },
        onError: (error) => {
          setIsLoading(false);
        },
      })
    );
  }, [filter.missing, filter.submitted]);

  useEffect(() => {
    setShownGrades(grades.filter((e) => selectedSections.includes(e.sectionNumber)));
  }, [selectedSections, grades]);

  // const handleChange = (e) => {
  //   setFilter({...filter, [e.target.name]: e.target.checked });
  // };
  // const handleClick = () => setFilter({missing: false, submitted: false});

  return (
    <div
      className='tab-pane fade show active'
      id='Contents'
      role='tabpanel'
      aria-labelledby='Contents-tab'
    >
      <div className='Contents_tabs'>
        <div className='' id='myContents'>
          <div className='grades_header w-40'>
            <DropDown
              className='w-40'
              title='Section Select'
              options={sections.map((e) => ({
                title: e.sectionName + ' | ' + e.sectionNumber.split('-')[0],
                value: e.sectionNumber,
                isChecked: selectedSections.includes(e.sectionNumber),
              }))}
              type={'checkbox'}
              onChange={(e) => {
                setSelectedSections((old) => {
                  if (old.includes(e.target.value)) {
                    return old.filter((l) => l !== e.target.value);
                  } else {
                    return [...old, e.target.value];
                  }
                });
              }}
            />
            {/* TODO: Dont remove this code. Its done functionality will uncomment after MVP release */}
            {/* <div className="d-flex align-items-center gap-4">
              <div className="d-flex align-items-center gap-2 cust border-0 bg-white">
                <input id="checkbox1" type="checkbox" name="submitted" checked={filter.submitted} onChange={handleChange} />
                <label className="drop_down_list cursor fw-semibold text-grey-700 mt-2p fs-12" htmlFor="checkbox1">Submitted</label>
              </div>
              <div className="d-flex align-items-center gap-2 cust border-0 bg-white">
                <input id="checkbox2" type="checkbox" name="missing" checked={filter.missing} onChange={handleChange} />
                <label htmlFor="checkbox2" className="drop_down_list cursor fw-semibold text-grey-700 mt-2p fs-12">Missing</label>
              </div>
              <button type="button" className="cursor save-btn rounded-0 fw-semibold text-grey-700 fs-12" onClick={handleClick}>
                Clear
              </button>
            </div> */}
          </div>
          {isLoading ? 'Loading...' : <GradesTable grades={shownGrades} onToggle={onToggle} />}
        </div>
      </div>
    </div>
  );
};

export default Grades;
